export default __webpack_public_path__ + "static/media/12.a68fd3b1.jpg";